import { RuntimeReactContext, getInitialContext } from "./runtime";
var globalContext = {};
import { getServerPayload, setServerPayload } from "./serverPayload/index";
function getGlobalIsRscClient() {
  return globalContext.isRscClient;
}
function getGlobalEnableRsc() {
  return globalContext.enableRsc;
}
function setGlobalContext(context) {
  globalContext.entryName = context.entryName;
  globalContext.App = context.App;
  globalContext.routes = context.routes;
  globalContext.appInit = context.appInit;
  globalContext.appConfig = typeof context.appConfig === "function" ? context.appConfig() : context.appConfig;
  globalContext.layoutApp = context.layoutApp;
  globalContext.RSCRoot = context.RSCRoot;
  globalContext.isRscClient = context.isRscClient;
  globalContext.enableRsc = context.enableRsc;
}
function getCurrentEntryName() {
  return globalContext.entryName;
}
function getGlobalRSCRoot() {
  return globalContext.RSCRoot;
}
function setGlobalInternalRuntimeContext(context) {
  globalContext.internalRuntimeContext = context;
}
function getGlobalInternalRuntimeContext() {
  return globalContext.internalRuntimeContext;
}
function getGlobalApp() {
  return globalContext.App;
}
function getGlobalRoutes() {
  return globalContext.routes;
}
function getGlobalAppInit() {
  var _getGlobalApp, _getGlobalLayoutApp;
  return globalContext.appInit || ((_getGlobalApp = getGlobalApp()) === null || _getGlobalApp === void 0 ? void 0 : _getGlobalApp.init) || ((_getGlobalLayoutApp = getGlobalLayoutApp()) === null || _getGlobalLayoutApp === void 0 ? void 0 : _getGlobalLayoutApp.init);
}
function getGlobalAppConfig() {
  var _getGlobalApp, _getGlobalLayoutApp;
  return globalContext.appConfig || ((_getGlobalApp = getGlobalApp()) === null || _getGlobalApp === void 0 ? void 0 : _getGlobalApp.config) || ((_getGlobalLayoutApp = getGlobalLayoutApp()) === null || _getGlobalLayoutApp === void 0 ? void 0 : _getGlobalLayoutApp.config);
}
function getGlobalLayoutApp() {
  return globalContext.layoutApp;
}
export {
  RuntimeReactContext,
  getCurrentEntryName,
  getGlobalApp,
  getGlobalAppConfig,
  getGlobalAppInit,
  getGlobalEnableRsc,
  getGlobalInternalRuntimeContext,
  getGlobalIsRscClient,
  getGlobalLayoutApp,
  getGlobalRSCRoot,
  getGlobalRoutes,
  getInitialContext,
  getServerPayload,
  setGlobalContext,
  setGlobalInternalRuntimeContext,
  setServerPayload
};
